import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" data-id="element-32">
      {/* Background Image with Heavy Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/9CUPttAskT7kJR4HfeqMfs/Gemini_Generated_Image_4qlzcp4qlzcp4qlz.png")'
    }} data-id="element-33" />
      <div className="absolute inset-0 z-10 bg-navy/80 backdrop-blur-sm" data-id="element-34" />

      <div className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-36">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading text-warmWhite mb-12 leading-tight text-balance" data-id="element-37">
            {t('finalCta.headline1')}{' '}
            <span className="text-saffron italic" data-id="element-38">
              {t('finalCta.headline2')}
            </span>
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20" data-id="element-39">
            <button onClick={() => scrollTo('support')} className="w-full sm:w-auto px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite transition-colors duration-300" data-id="element-40">
              {t('finalCta.cta1')}
            </button>
            <button onClick={() => scrollTo('founding')} className="w-full sm:w-auto px-8 py-4 bg-transparent border border-warmWhite/50 text-warmWhite rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite/10 hover:border-warmWhite transition-colors duration-300" data-id="element-41">
              {t('finalCta.cta2')}
            </button>
            <button onClick={() => scrollTo('partner')} className="w-full sm:w-auto px-8 py-4 bg-transparent text-warmWhite rounded-sm text-sm tracking-widest uppercase font-medium hover:text-saffron transition-colors duration-300" data-id="element-42">
              {t('finalCta.cta3')}
            </button>
          </div>
        </motion.div>

        {/* Footer */}
        <div className="border-t border-warmWhite/20 pt-8 flex flex-col md:flex-row justify-between items-center text-warmWhite/50 text-sm" data-id="element-43">
          <p data-id="element-44">{t('finalCta.copyright')}</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-45">
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-46">
              {t('finalCta.contact')}
            </a>
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-47">
              {t('finalCta.inquiries')}
            </a>
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-48">
              {t('finalCta.privacy')}
            </a>
          </div>
        </div>
      </div>
    </section>;
}